import { DailyAdvice } from '@app/shared/components/disease-overview-table.component/models/models';
import { SprayAdvice } from '../../models/models';

export type CssStyling = { [key: string]: string } | null | undefined;
export type AdvicePalette = 'neutral' | 'preventive' | 'curative' | 'stop';

const defaultStyling: CssStyling = { color: '#18181B', fontFamily: 'Akkurat', fontSize: '12px' };

const noAdviceStyling: CssStyling = { ...defaultStyling, 'background-color': '#FAFAFA' };
const preventiveStyling: CssStyling = { ...defaultStyling, 'background-color': '#fff0b0' };
const curativeStyling: CssStyling = { ...defaultStyling, 'background-color': '#f49433' };
const stopSprayStyling: CssStyling = { ...defaultStyling, 'background-color': '#b5061a', color: 'white' };

const cropsProtectedStyling = (remainingFungicidePercentage: number): CssStyling => ({
  ...defaultStyling,
  'background-color': remainingFungicidePercentage === 0 ? '#FAFAFA' : `rgba(39, 144, 73, ${remainingFungicidePercentage}%)`,
  color: remainingFungicidePercentage > 50 ? '#FAFAFA' : '#18181B',
});

export const getAdvice = (value: number): SprayAdvice => {
  switch (value) {
    case 0:
      return SprayAdvice.cropsProtected;
    case 1:
      return SprayAdvice.preventive;
    case 2:
      return SprayAdvice.curative;
    case 3:
      return SprayAdvice.stop;
    case -1:
    default:
      return SprayAdvice.noAdvice;
  }
};

export const getSprayTypeTranslation = (
  { sprayAdvice, remainingFungicidePercentage }: DailyAdvice,
  translationPrefix = 'blightV2',
): string => {
  const prefix = `${translationPrefix}.sprayAdvice`;
  switch (sprayAdvice) {
    case SprayAdvice.cropsProtected:
      return remainingFungicidePercentage === 0 ? `${prefix}.sprayNotNeeded` : `${prefix}.cropsProtected`;
    case SprayAdvice.preventive:
      return `${prefix}.preventive`;
    case SprayAdvice.curative:
      return `${prefix}.curative`;
    case SprayAdvice.stop:
      return `${prefix}.stop`;
    case SprayAdvice.noAdvice:
    default:
      return `${prefix}.noAdvice`;
  }
};

export const getAdvicePaletteStyling = (palette: AdvicePalette): CssStyling => {
  switch (palette) {
    case 'preventive':
      return preventiveStyling;
    case 'curative':
      return curativeStyling;
    case 'stop':
      return stopSprayStyling;
    case 'neutral':
    default:
      return noAdviceStyling;
  }
};

export const getSprayTypeStyling = ({ sprayAdvice, remainingFungicidePercentage }: DailyAdvice): CssStyling => {
  switch (sprayAdvice) {
    case SprayAdvice.cropsProtected:
      return cropsProtectedStyling(remainingFungicidePercentage);
    case SprayAdvice.preventive:
      return getAdvicePaletteStyling('preventive');
    case SprayAdvice.curative:
      return getAdvicePaletteStyling('curative');
    case SprayAdvice.stop:
      return getAdvicePaletteStyling('stop');
    case SprayAdvice.noAdvice:
    default:
      return getAdvicePaletteStyling('neutral');
  }
};
